<template>
    <div class="tab-game">
        <p class="tab-game__item" :class="{ 'active': gameSelectedId == game.id }" v-for="(game, index) in games"
            :key="index" @click="selecteGames(game)">
            {{ game.name }}
        </p>
    </div>
</template>
<script>
import HomeService from "@/services/home/index.service.ts";

export default {
    data() {
        return {
            games: [],
            gameSelectedId: 0,
            fetchingMarket: false,
        }
    },

    mounted() {
        this.ensureGames();
    },

    watch: {
        "$store.state.gameMarket"() {
            this.handleInitGames();
        },
    },

    methods: {
        async ensureGames() {
            if ((this.$store.state.gameMarket || []).length > 0) {
                this.handleInitGames();
                return;
            }
            if (this.fetchingMarket) return;
            this.fetchingMarket = true;
            try {
                const res = await HomeService.getGameMarket();
                if (res?.status === "success" && Array.isArray(res.result)) {
                    this.$store.commit("SET_GAME_MARKET", res.result);
                } else {
                    this.handleInitGames();
                }
            } catch {
                this.handleInitGames();
            } finally {
                this.fetchingMarket = false;
            }
        },

        handleInitGames() {
            this.games = this.$store.state.gameMarket || [];
            if (!this.games.length) {
                this.gameSelectedId = 0;
                return;
            }

            const slug = this.$store.state.stateAction.gameSlugSelected;
            const gameAllowSlug = this.games.find(x => x.slug === slug);
            const defaultGame = gameAllowSlug ?? this.games[0];

            this.gameSelectedId = defaultGame.id;
            this.$emit("game-default", defaultGame);
            //reset tab slug
            this.$store.commit("setGameSlug", "");
        },

        selecteGames(game) {
            this.gameSelectedId = game.id;
            this.$emit('select-game', game)
        }
    }
}
</script>

<style lang="scss">
@import "@/public/scss/common/tab/tab-game.scss";
</style>